import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsPreview() {
  const items = newsList.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100 border-t border-background-300/60">
      <div className="w-full max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3">
          <div>
            <p className="font-label text-[11px] tracking-[0.26em] uppercase text-accent-500">
              Latest News
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              近期影视资讯
            </h2>
          </div>
          <Link
            to="/news"
            className="inline-flex items-center gap-1.5 text-xs md:text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部资讯
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-7 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((item) => (
            <Link
              key={item.id}
              to={`/news/detail/${item.id}`}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-300/60 hover:border-primary-500/70 transition-colors cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title} 配图`}
                  title={`${item.title} - 日韩黄色电影资讯`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2 py-1 rounded-md bg-background-50/85 backdrop-blur-sm text-[10px] text-foreground-800">
                  {item.category}
                </span>
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col">
                <h3 className="text-sm md:text-base leading-snug text-foreground-900 group-hover:text-accent-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-xs md:text-[13px] leading-relaxed text-foreground-500 line-clamp-2">
                  {item.summary}
                </p>
                <div className="mt-auto pt-4 flex items-center justify-between text-[11px] text-foreground-400">
                  <span>{item.date}</span>
                  <span className="flex items-center gap-1 text-foreground-500 group-hover:text-accent-500 transition-colors">
                    阅读全文
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}